/**
 * 语言切换 Hook
 */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE, LANGUAGES, type LanguageCode } from '@/locales'

export const useLanguage = () => {
  const { i18n } = useTranslation()

  // 当前语言
  const currentLanguage = i18n.language as LanguageCode

  // 当前语言信息
  const currentLanguageInfo =
    LANGUAGES.find((lang) => lang.code === currentLanguage)
    || LANGUAGES.find((lang) => lang.code === DEFAULT_LANGUAGE)
    || LANGUAGES[0]

  // 切换语言
  const changeLanguage = useCallback(
    (lang: LanguageCode) => {
      i18n.changeLanguage(lang)
    },
    [i18n]
  )

  // 是否为中文
  const isZhCN = currentLanguage === 'zh-CN'

  // 是否为英文
  const isEnUS = currentLanguage === 'en-US'

  return {
    currentLanguage,
    currentLanguageInfo,
    languages: LANGUAGES,
    changeLanguage,
    isZhCN,
    isEnUS,
  }
}
